









'use strict';

var RequestAnimationFrame={
current:function current(cb){return global.requestAnimationFrame(cb);},
inject:function inject(injected){
RequestAnimationFrame.current=injected;
}};


module.exports=RequestAnimationFrame;


/*****************
 ** WEBPACK FOOTER
 ** ./~/animated/lib/injectable/RequestAnimationFrame.js
 ** module id = 129
 ** module chunks = 0
 **/